/* Affiliate outbound-click tracking. Sends a beacon; never changes or delays the link. */
(function () {
  if (window.__affClickTracking) return;
  window.__affClickTracking = true;
  var ENDPOINT = 'https://shopify.josenaranjo.dev/api/v1/aff-click';
  var last = { href: '', t: 0 };
  function send(a) {
    try {
      var now = Date.now();
      if (a.href === last.href && now - last.t < 800) return;
      last = { href: a.href, t: now };
      var card = a.closest('.affiliate-gift-guide__card');
      var titleEl = card && card.querySelector('.affiliate-gift-guide__title, h3');
      var sec = a.closest('[id^="shopify-section-"]');
      var u = new URL(a.href);
      var payload = JSON.stringify({
        title: (titleEl ? titleEl.textContent : a.textContent || '').trim().slice(0, 200),
        host: u.hostname,
        url: (u.origin + u.pathname).slice(0, 300),
        section: sec ? sec.id.split('__').pop() : '',
        page: location.pathname + location.search,
        vw: window.innerWidth,
        theme: (window.Shopify && Shopify.theme && Shopify.theme.id) || '',
        ts: new Date().toISOString()
      });
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'text/plain' }))) return;
      fetch(ENDPOINT, { method: 'POST', body: payload, mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' } });
    } catch (e) {}
  }
  function handler(e) {
    if (e.type === 'auxclick' && e.button !== 1) return;
    var a = e.target && e.target.closest && e.target.closest('a[rel~="sponsored"]');
    if (a && a.href) send(a);
  }
  document.addEventListener('click', handler, true);
  document.addEventListener('auxclick', handler, true);
})();
